/**
 * Node text comes back from the backend as a single string with an intro
 * (context/setup) and the actual problem statement run together. The
 * backend marks the boundary with this delimiter on its own line; splitting
 * on it here keeps the two parts styled and laid out differently.
 *
 * Kept loose about surrounding whitespace/newlines since the delimiter can
 * land anywhere relative to line breaks depending on how the model formats
 * it.
 */
const NODE_TEXT_DELIMITER = /\n{0,2}@@PROBLEM@@\n{0,2}/;

export interface SplitNodeText {
    intro: string;
    problem: string;
    /** False until the delimiter itself has fully arrived (relevant while streaming). */
    hasProblem: boolean;
}

export function splitNodeText(text: string): SplitNodeText {
    const match = text.match(NODE_TEXT_DELIMITER);

    if (!match || match.index === undefined) {
        // Delimiter hasn't arrived yet (or never will, e.g. old cached
        // responses generated before this split existed) — treat it all as
        // the problem statement so nothing is lost/hidden.
        return {intro: "", problem: text, hasProblem: false};
    }

    return {
        intro: text.slice(0, match.index),
        problem: text.slice(match.index + match[0].length),
        hasProblem: true,
    };
}
